<template>
    <div class="documents-style">
        <b-alert show dismissible fade v-if='successmsg'>{{ successmsg }}</b-alert>

        <div class="row no-gutters py-2 mb-3">
            <div class="col-sm-5 company-form-box-title">
                <div class="custom-search ess-leave-list">
                    <b-input-group>
                        <b-input-group-prepend is-text>
                            <b-icon icon="search"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input type="search" placeholder="Search..." v-model="search"
                            @input="resetPagination()"></b-form-input>
                    </b-input-group>
                </div>
            </div>
            <div class="col-sm-7 cursor-pointer text-right company-form-box-title">
                <b-button @click="downloadSelected()">Download Selected</b-button>
            </div>
        </div>

        <div class="employee-table-wrapper table-sticky-height">
            <b-overlay :show="showoverlay_list" rounded="sm">
                <table
                    class="employee-list-table table-overflow table-sticky ess-custom-table document-table tax-documents table-list fund_list_table document-custom-sorting-table-btn">
                    <thead>
                        <tr class="table-head">
                            <td class="checkbox-col">
                                <input type="checkbox" v-model="checkall" @click="selectAll()">
                                <!-- <input type="checkbox" v-model="checkall" @click="selectAll()"> -->
                                <label></label>
                            </td>
                            <!-- <td class ="checkbox-col"><input type="checkbox" v-model="checkall" @click="selectAll()" /></td> -->
                            <!-- <th class="checkbox"><input type="checkbox" v-model="checkall" @click="selectAll()" /></th> -->
                            <template v-for="column in columns">
                                <th @click="sortBy(column.name)"
                                    :class="sortKey === column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                                    style="cursor:pointer;"><label class="custom-label-doc">{{ column.label }}<span
                                            class="custom-date-indicator d-block ess-date-indicator"
                                            v-if="column.name === 'created_at'">(YYYY-MM-DD)</span></label>
                                </th>
                            </template>
                            <th class="document-list-file-th"><label class="custom-label-doc">File</label></th>

                        </tr>
                    </thead>

                    <tbody class="table-body">
                        <tr class="hover-bg table-row" v-for="doc in paginatedData" :key="doc.id">
                            <td class="checkbox-col">
                                <input type="checkbox" class="justify-content-center checkall_hr"
                                    v-if="doc.file_name != ''" v-model="checked_list" :value="'uploaded:' + doc.id" />
                                <label></label>
                            </td>
                            <td class="cursor-pointer trz_relative">{{ doc.name }}</td>
                            <td class="cursor-pointer trz_relative">{{ doc.created_at.split('T')[0] }}</td>
                            <!-- Abdullah26 added class  -->
                            <td class="cursor-pointer trz_relative file mobile-padding-right">
                                <div class="download-file-link" v-if="doc.file_name">
                                    <b-link
                                        @click="downloadFileContent('data/hrpolicyhandbook/' + doc.company_id + '/' + doc.file_name)">
                                        <img :src="$api_url + '/images/download_image.png'" class="" />
                                    </b-link>
                                </div>
                            </td>
                        </tr>

                    </tbody>
                </table>

                <div class="">
                    <div class="clearfix mt-2 mb-4">
                        <ul class="pagination b-pagination float-left mb-0 mt-1">
                            <li class="page-item disabled m-2">View</li>
                            <li class="page-item disabled"><b-form-select v-model="temp_length"
                                    :options="length_options" @change="setFirstPage()"></b-form-select></li>
                            <li class="page-item disabled m-2">per page. Total {{ documents.length }} records found.</li>
                        </ul>
                        <b-pagination-nav class="float-right mt-1" v-model="pagination.currentPage"
                            :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#"
                            first-number last-number></b-pagination-nav>

                    </div>
                </div>
            </b-overlay>

            <!-- <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">
                {{blankmsg}}
            </div>
            <div v-else class="px-3">
                <div class="row py-2 no-margin" v-if="paginatedData.length > 0">
                    <div class="col-md-12 p-0 no-margin" v-if="paginatedData.length > 0">

                        <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" first-number last-number ></b-pagination-nav>
                    </div>

                </div> -->
        </div>



    </div>


    <!-- </div> -->

</template>


<script>
export default {

    mounted() {

    },
    props: ['flg'],
    data() {

        let sortOrders = {};
        let columns = [
            { label: 'Name', name: 'name' },
            { label: 'Date Uploaded', name: 'created_at' },

        ];
        columns.forEach((column) => { sortOrders[column.name] = -1; });

        return {

            checked_list: [],
            checkall: false,

            documents: [],
            successmsg: null,
            errormsg: [],
            showoverlay: false,
            fdata: { id: null, name: null },
            upload_file: null,

            blankmsg: 'Fetching data..',
            search: '',

            columns: columns,
            sortKey: 'name',
            sortOrders: sortOrders,
            length: 20,
            // pagination : {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},

            temp_length: 20,
            showoverlay_list: false,
            pagination: { currentPage: 1, pages: 1 },

            length_options: [{ value: 20, text: "20" },
            { value: 50, text: "50" },
            { value: 100, text: "100" },
            { value: 200, text: "200" },
            { value: 500, text: "500" },],

        }
    },
    methods: {
        downloadSelected: function () {
            if (this.checked_list.length == 0) {
                this.$bvToast.toast('No document selected.', {
                    title: `Warning`,
                    variant: 'warning',
                    solid: true
                });

                return false;
            }

            if (!this.checkNet()) return false;
            let currentObj = this;

            let url = '';
            url = this.$api_url + '/front/documents/zip/download';

            this.$bvToast.toast('It might take a while', {
                title: `Info`,
                variant: 'info',
                solid: true
            });

            let formData = new FormData();

            formData.append('checked_list', this.checked_list);
            formData.append('type', 'hr');



            axios.post(url, formData)
                .then(function (response) {
                    this.downloadFileContent(response.data);
                }.bind(this)).catch(function (error) { currentObj.serverError(error); });
        },
        selectAll: function () {
            this.checkall = !this.checkall;
            var y = document.getElementsByClassName("checkall_hr");
            var i;
            for (i = 0; i < y.length; i++) {
                if (y[i].checked != this.checkall)
                    y[i].click();
            }
        },
        getDocumentList: function () {
            if (!this.checkNet()) return false;
            let currentObj = this;
            axios.get(this.$api_url + '/front/hr-policy-handbook/employee', {
                params: {
                    //employee_id: this.employeeId
                }
            }).then(function (response) {
                this.documents = response.data;

                if (this.documents.length == 0)
                    this.blankmsg = "No doucments found";

                else {
                    this.sortOrders['created_at'] = 1;
                    this.sortBy('created_at');
                }
            }.bind(this)).catch(function (error) { currentObj.serverError(error); });
        },

    },
    created: function () {
        this.getDocumentList();
        Fire.$on('reloaddocuments', () => { this.getDocumentList() })
    },
    computed:
    {
        filteredData() {
            let filtered_list = this.documents;
            if (this.search) {
                filtered_list = filtered_list.filter((row) => { return Object.keys(row).some((key) => { return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1; }) });

                if (filtered_list.length == 0)
                    this.blankmsg = "No doucments found";
            }

            let sortKey = this.sortKey;
            let order = this.sortOrders[sortKey] || 1;
            if (sortKey) {
                filtered_list = filtered_list.slice().sort((a, b) => {
                    let index = this.getIndex(this.columns, 'name', sortKey);
                    a = String(a[sortKey]).toLowerCase();
                    b = String(b[sortKey]).toLowerCase();
                    if (this.columns[index].type && this.columns[index].type === 'date') {
                        return (a === b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
                    }
                    else if (this.columns[index].type && this.columns[index].type === 'number') {
                        return (+a === +b ? 0 : +a > +b ? 1 : -1) * order;
                    }
                    else {
                        return (a === b ? 0 : a > b ? 1 : -1) * order;
                    }
                }
                );
            }

            return filtered_list;
        },
        paginatedData() {
            return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
        }
    }

}
</script>
